import { ChangeDetectorRef, OnInit } from '@angular/core';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { Constants } from '../../../shared/config/constants.config';
import * as moment from 'moment';
import { WalletService } from '../../services/wallet.service';
import { CountriesService } from '../../../shared/services/countries.service';
import { forkJoin } from 'rxjs';
import { LocalisationService } from '../../../shared/services/localisation.service';
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent(countriesService, walletService, localisationService, changeDetectorRef, appLoadingEventsEmitter, constants) {
        this.countriesService = countriesService;
        this.walletService = walletService;
        this.localisationService = localisationService;
        this.changeDetectorRef = changeDetectorRef;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.constants = constants;
        this.transactions = [];
        this.selected_country = 'BG';
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin([
            this.countriesService.getCountries(),
            this.walletService.getTransactions(0),
            this.walletService.getPayoutSetting()
        ]).subscribe(function (_a) {
            var countries = _a[0], transactions = _a[1], payoutSetting = _a[2];
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.countries = countries;
            _this.transactions = transactions;
            _this.paypal_email = payoutSetting.paypal_email;
            if (payoutSetting.transfer_method_country.length > 0) {
                _this.selected_country = payoutSetting.transfer_method_country;
            }
        });
    };
    SettingsComponent.prototype.formatDate = function (created_at) {
        return moment(created_at).format('DD.MM.YYYY / HH:mm');
    };
    SettingsComponent.prototype.onCountryChange = function ($event) {
        // @ts-ignore
        this.selected_country = event.target.value;
    };
    SettingsComponent.prototype.update = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.walletService.updatePayoutSettings({ paypal_email: this.paypal_email, country: this.selected_country }).subscribe(function (response) {
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, function () {
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            alert(_this.localisationService.localise('fill_all_fields'));
        });
    };
    return SettingsComponent;
}());
export { SettingsComponent };
